import { TOKENS } from '../../hooks/useTheme';
import type { Theme } from '../../types';

interface BlobsProps {
  theme: Theme;
}

export function Blobs({ theme }: BlobsProps) {
  const op = theme.dark ? 0.55 : 0.6;
  return (
    <svg
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        mixBlendMode: theme.dark ? 'screen' : 'multiply',
        zIndex: 0,
      }}
      viewBox="0 0 1600 2200"
      preserveAspectRatio="xMidYMin slice"
    >
      <path
        d="M1400 -60 C 1560 80, 1700 280, 1500 380 C 1340 460, 1140 380, 1120 240 C 1100 100, 1240 -60, 1400 -60 Z"
        fill={theme.acc}
        opacity={op * 0.18}
      />
      <path
        d="M-160 880 C 80 760, 360 880, 320 1040 C 280 1200, 20 1240, -120 1120 C -260 1000, -300 1000, -160 880 Z"
        fill={TOKENS.moss}
        opacity={op * 0.14}
      />
      <path
        d="M1340 1620 C 1520 1580, 1660 1780, 1500 1900 L 1180 1900 C 1160 1780, 1240 1660, 1340 1620 Z"
        fill={TOKENS.rose}
        opacity={op * 0.16}
      />
    </svg>
  );
}
